import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
//import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { PaginadorRemoto } from 'src/app/_class/paginador-remoto.class';
import {faChevronLeft, faChevronRight} from '@fortawesome/pro-solid-svg-icons'
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-paginator-cz',
  templateUrl: './paginator-cz.component.html',
  styleUrls: ['./paginator-cz.component.css']
})
export class PaginatorCzComponent implements OnInit, OnChanges {
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  selected: any = 10;
  @Input() modelo: PaginadorRemoto<any>;
  @Output() onNextPage = new EventEmitter<any>();
  @ViewChild('itemsPerPage') itemsPerPage !: ElementRef;
  options: number[] = [];

  constructor() {

   }

  ngOnChanges(changes:SimpleChanges): void {

    this.selected = this.modelo.tamanoPagina;
  }

  ngOnInit(): void {

    this.options = [10,25,50];
    this.selected = this.modelo.tamanoPagina;
  }

  changeItemsPerPage() {
    this.selected = this.itemsPerPage.nativeElement.value;
    this.modelo.tamanoPagina = parseInt(this.itemsPerPage.nativeElement.value);
    this.nextPage(1, true);
  }

  nextPage(direction: number, refresh: boolean = false) {
    var obj = {
      tamano: this.modelo.tamanoPagina,
      pagina: refresh ? direction : direction === -1 ? this.modelo.actual - 1 : this.modelo.actual + 1
    }

    this.onNextPage.emit(obj);
  }

}
